var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import * as HoverCardPrimitive from "@radix-ui/react-hover-card";
import { cn } from "../../lib/utils.js";
/**
 * InfoCard – Hover preview for items (e.g., drawer links).
 * Wrap your trigger element with `InfoCardTrigger`, then declare one `InfoCardContent`.
 */
export var InfoCard = HoverCardPrimitive.Root;
export var InfoCardTrigger = HoverCardPrimitive.Trigger;
var BASE_CLASSES = "z-50 w-80 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none " +
    "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 " +
    "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 " +
    "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 " +
    "data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 " +
    "origin-[--radix-hover-card-content-transform-origin]";
export var InfoCardContent = React.forwardRef(function (_a, ref) {
    var heading = _a.heading, description = _a.description, preview = _a.preview, className = _a.className, _b = _a.sideOffset, sideOffset = _b === void 0 ? 8 : _b, _c = _a.portal, portal = _c === void 0 ? true : _c, props = __rest(_a, ["heading", "description", "preview", "className", "sideOffset", "portal"]);
    var content = (_jsxs(HoverCardPrimitive.Content, __assign({ ref: ref, sideOffset: sideOffset, className: cn(BASE_CLASSES, className) }, props, { children: [_jsx(HoverCardPrimitive.Arrow, { className: "fill-border" }), _jsxs("div", { className: "space-y-2", children: [_jsx("h3", { className: "font-semibold text-base leading-5 text-foreground truncate", title: heading, children: heading }), description && (_jsx("p", { className: "text-sm text-muted-foreground leading-relaxed", children: description })), preview && _jsx("div", { className: "pt-2", children: preview })] })] })));
    return portal ? _jsx(HoverCardPrimitive.Portal, { children: content }) : content;
});
InfoCardContent.displayName = "InfoCardContent";
